import React from 'react';
import { Breadcrumb as BSBreadcrumb } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';

/**
 * 面包屑导航组件
 * 显示当前页面在系统中的层级位置
 * @returns {JSX.Element} 返回面包屑导航组件
 */
function Breadcrumb() {
    const location = useLocation();

    // 路径映射配置
    const pathMap = {
        '': '首页',
        doctors: '医生管理', // 修改为与菜单一致的名称
        doctorDetail: '医生明细',
        store: '设备管理',
        knowledge: '知识库',
        documents: '文档管理',
        categories: '分类管理',
        tags: '标签管理',
        create: '创建文档',
        edit: '编辑文档',
    };

    // 根据路径生成面包屑项
    const pathSegments = location.pathname.split('/').filter(Boolean);

    const breadcrumbItems = [
        { path: '/', label: '首页' },
        ...pathSegments.map((segment, index) => ({
            path: `/${pathSegments.slice(0, index + 1).join('/')}`,
            label: Number(segment)
                ? pathMap['doctorDetail']
                : pathMap[segment] || segment,
        })),
    ];

    return (
        <BSBreadcrumb className="ms-3 mt-3 mb-0">
            {breadcrumbItems.map((item, index) => (
                <BSBreadcrumb.Item
                    key={item.path}
                    linkAs={Link}
                    linkProps={{ to: item.path }}
                    active={index === breadcrumbItems.length - 1}
                >
                    {item.label}
                </BSBreadcrumb.Item>
            ))}
        </BSBreadcrumb>
    );
}

export default Breadcrumb;
